<template>
	<div>
		<div class="margin-top-20" style="width: 90%">
			<b-tag
				type="is-info"
				size="is-large"
				class="margin-top-20"
				style="width: 420px"
			>
				Search stock item
			</b-tag>
		</div>
		<div v-if="loadingStockItems" class="loading-tag">Loading...</div>
		<div v-if="!loadingStockItems">
			<div class="margin-top-20">
				<ve-table
					:rows="listArr"
					:columns="columnsList"
					:onCellClick="onCellClick"
					:onRowDoubleClick="onRowDoubleClick"
					:perPage="perPageProp"
					maxHeight="350px"
				>
				</ve-table>
			</div>
		</div>
	</div>
</template>

<script>
import { computed, onMounted, reactive, ref } from '@vue/composition-api'
import { useQuery } from '@vue/apollo-composable'
import usePurchaseInvoiceHeaderState from '@/_srcv2/pages/purchase-invoice/add-purchase-invoice/subcomponents/get-purchase-invoice-headers/usePurchaseInvoiceHeaderState.js'
import storeSearchStockItemState from '@/_srcv2/pages/purchase-invoice/add-purchase-invoice/subcomponents/search-stock-item/useSearchStockItemState.js'
import usePurchaseInvoiceModalState from '@/_srcv2/pages/purchase-invoice/add-purchase-invoice/subcomponents/add-purchase-invoice-lines/usePurchaseInvoiceModalState.js'
import SearchStockItemQuery from '@/_srcv2/pages/purchase-invoice/add-purchase-invoice/subcomponents/search-stock-item/SearchStockItemQuery.graphql'
export default {
	name: 'SearchStockItemToAddToPurchaseInvoice',
	setup() {
		const perPageProp = ref(10)
		const { ourCompanyPurchaseInvoice, customerIdPurchaseInvoice } =
			usePurchaseInvoiceHeaderState()
		const labelPosition = ref('on-border')
		const ourCompany = computed(() => ourCompanyPurchaseInvoice.value)
		// ------------------------------------------------------------
		const options = reactive({
			fetchPolicy: 'no-cache',
		})
		const { refetch: refetchStockItems, loading: loadingStockItems } = useQuery(
			SearchStockItemQuery,
			() => ({
				company_id: ourCompany.value,
			}),
			options,
		)
		// Create Table
		const tableValues = ref([])
		const getData = () => {
			tableValues.value = []
			refetchStockItems().then((result) => {
				tableValues.value = result.data.stock.map((item) => {
					return {
						stockId: item.stock_id,
						itemName: item.stock_name,
						amount:
							item.outstanding_balance + item.debit_amount - item.credit_amount,
						stockUnit: item.stock_unit,
					}
				})
			})
		}
		const listArr = computed(() => tableValues.value)
		// -------------------------------------------------------------------------
		const { purchaseInvoiceModalState } = usePurchaseInvoiceModalState()
		const setPurchaseInvoiceModalState = (item) => {
			console.log('selected stock item', item)
			purchaseInvoiceModalState.ourCompany = ourCompanyPurchaseInvoice
			purchaseInvoiceModalState.customerId = customerIdPurchaseInvoice
			purchaseInvoiceModalState.stockId = item.stockId
			purchaseInvoiceModalState.lineInfo = `${item.stockId} - ${item.itemName} - ${item.stockUnit}`
			purchaseInvoiceModalState.isModalVisible = true
			purchaseInvoiceModalState.isAddOrEdit = 'add'
			purchaseInvoiceModalState.keyModal =
				purchaseInvoiceModalState.keyModal + 1
			console.log('purchaseInvoiceModalState', purchaseInvoiceModalState)
		}
		const onCellClick = (params) => {
			if (params.column.field === 'select') {
				const item = params.row
				setPurchaseInvoiceModalState(item)
			}
		}
		const onRowDoubleClick = (params) => {
			const item = params.row
			setPurchaseInvoiceModalState(item)
		}
		// -------------------------------------------------------------------------
		const { columnsList } = storeSearchStockItemState()
		// -------------------------------------------------------------------------
		onMounted(() => {
			tableValues.value = []
			getData()
		})
		return {
			perPageProp,
			labelPosition,
			getData,
			listArr,
			columnsList,
			loadingStockItems,
			onCellClick,
			onRowDoubleClick,
		}
	},
}
</script>

<style scoped>
.loading-tag {
	font-size: 2em;
	font-weight: bolder;
	color: #9b1c1c;
}
</style>
